namespace Matrix.Workflow {
    export interface ClientFunctionScheduleForm {
        ScheduleName: Serenity.StringEditor;
    }

    export class ClientFunctionScheduleForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.ClientFunctionSchedule';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ClientFunctionScheduleForm.init)  {
                ClientFunctionScheduleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(ClientFunctionScheduleForm, [
                    'ScheduleName', w0
                ]);
            }
        }
    }
}
